import React from 'react';

export interface LayersIconProps {}

export const LayersIcon: React.FC<LayersIconProps> = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 18.54L19.37 12.8L21 14.07L12 21.07L3 14.07L4.62 12.81L12 18.54ZM12 16L3 9L12 2L21 9L12 16ZM12 4.53L6.26 9L12 13.47L17.74 9L12 4.53Z"
        fill="#192033"
      />
    </svg>
  );
};
